/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ICreditReportSlice {
  isShowCreditReportModal: boolean;
  activeCreditReportModal:
    | 'enableCreditModal'
    | 'disableCreditModal'
    | 'showTermsAndConditionsModal'
    | '';
}

const initialState: ICreditReportSlice = {
  isShowCreditReportModal: false,
  activeCreditReportModal: ''
};

export const creditReportSlice = createSlice({
  name: 'creditReport',
  initialState,
  reducers: {
    setIsShowCreditReportModal: (state: ICreditReportSlice, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isShowCreditReportModal = payload;
    },
    setActiveCreditReportModal: (
      state: ICreditReportSlice,
      action: PayloadAction<
        'enableCreditModal' | 'disableCreditModal' | 'showTermsAndConditionsModal' | ''
      >
    ) => {
      const { payload } = action;
      state.activeCreditReportModal = payload;
    }
  }
});

const { actions, reducer } = creditReportSlice;

export const { setIsShowCreditReportModal, setActiveCreditReportModal } = actions;

export default reducer;
